import React, { useState } from "react";
import RefreshIcon from '@mui/icons-material/Refresh';
import {
  Box,
  CssBaseline,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import Sidebar from "./Sidebar";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const drawerWidth = 240; // Define drawerWidth here for consistency

const MainLayout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleProfileClick = () => {
    navigate("/profile");
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { md: `calc(100% - ${drawerWidth}px)` },
          ml: { md: `${drawerWidth}px` },
          zIndex: theme.zIndex.drawer + 1, // Ensure AppBar is above Drawer
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            Quản lý kho
          </Typography>
           <Button 
           color="inherit" 
           startIcon={<RefreshIcon />} onClick={() => window.location.reload(true)}>
            </Button>
          <Box sx={{ flexGrow: 1 }} />
          {user && (
            <>
              <Button
                startIcon={<ManageAccountsIcon />}
                color="inherit"
                onClick={handleProfileClick}
              >
                <strong>{user.name}</strong>
              </Button>
          </>
          )}
        </Toolbar>
      </AppBar>
      <Sidebar
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
        isMobile={isMobile}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: "16px 0 0 0",
          width: { md: `calc(100% - ${drawerWidth}px)` },
          ml: { md: `${drawerWidth}px` }, // Margin for desktop sidebar
          mt: { xs: "64px", md: "0" }, // Adjust margin-top for mobile AppBar (default AppBar height is 64px)
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default MainLayout;
